import React from 'react';
import VideoTutorialPresentational from './video-tutorial-presentational';

const VideoTutorialFunctional = () => {
	return <VideoTutorialPresentational />;
};

export default VideoTutorialFunctional;
